module.exports = __webpack_public_path__ + "static/media/sobre-missao.10d96bb5.png";